// File: src/components/Sidebar.js

import { useState, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './adminSidebar.css';
import {
  FaInbox,
  FaSpinner,
  FaCheckCircle,
  FaUserPlus,
  FaBullhorn,
  FaImages,
  FaRegNewspaper
} from 'react-icons/fa';

const Sidebar = () => {
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setCollapsed(true); 
            } else {
                setCollapsed(false);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Nav
            className={`flex-column sidebar ${collapsed ? 'collapsed' : ''}`}
            onMouseEnter={() => {
                if (window.innerWidth > 768) setCollapsed(false);
            }}
            onMouseLeave={() => {
                if (window.innerWidth > 768) setCollapsed(true);
            }}
        >
            <div className="sidebar-header">
                {collapsed ? (
                    <div className="collapsed-toggle">{'<<'}</div>
                ) : (
                    <h5>Menu Utama</h5>
                )}
            </div>

            <LinkContainer to="/admin/dashboard/masuk">
                <Nav.Link className="d-flex align-items-center">
                    <FaInbox className="me-2" />
                    <span>Laporan Masuk</span>
                </Nav.Link>
            </LinkContainer>

            <LinkContainer to="/admin/dashboard/proses">
                <Nav.Link className="d-flex align-items-center">
                    <FaSpinner className="me-2" />
                    <span>Laporan Diproses</span>
                </Nav.Link>
            </LinkContainer>

            <LinkContainer to="/admin/dashboard/selesai">
                <Nav.Link className="d-flex align-items-center">
                    <FaCheckCircle className="me-2" />
                    <span>Laporan Selesai</span>
                </Nav.Link>
            </LinkContainer>

            <hr />

            <LinkContainer to="/admin/dashboard/pengumuman">
                <Nav.Link className="d-flex align-items-center">
                    <FaBullhorn className="me-2" />
                    <span>Kelola Pengumuman</span>
                </Nav.Link>
            </LinkContainer>

            <LinkContainer to="/admin/dashboard/kegiatan">
                <Nav.Link className="d-flex align-items-center">
                    <FaImages className="me-2" />
                    <span>Kelola Kegiatan</span>
                </Nav.Link>
            </LinkContainer>

            <LinkContainer to="/admin/dashboard/berita">
                <Nav.Link className="d-flex align-items-center">
                    <FaRegNewspaper className="me-2" />
                    <span>Kelola Berita</span>
                </Nav.Link>
            </LinkContainer>

            <LinkContainer to="/admin/dashboard/register-admin">
                <Nav.Link className="d-flex align-items-center">
                    <FaUserPlus className="me-2" />
                    <span>Register Admin Baru</span>
                </Nav.Link>
            </LinkContainer>
        </Nav>
    );
};

export default Sidebar;
